module.exports = __webpack_public_path__ + "img/lunpic_34.967126b3.png";